export default function isDateToday(d) {
	let tzoffset = (new Date()).getTimezoneOffset() * 60000; //user's offset in milliseconds
	return new Date(d).toISOString().slice(0, 'YYYY-MM-DD'.length) === (new Date(Date.now() - tzoffset)).toISOString().slice(0, 'YYYY-MM-DD'.length);
}



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/lib/is-date-today.js